import { Dispatch, FC, PropsWithChildren, ReactNode, SetStateAction } from "react";
import styled from "@emotion/styled";

const Background = styled.div`
    position: fixed;
    z-index: 2;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.8);
`;

type TProps = {
    children: ReactNode;
    show: boolean;
    setShow: Dispatch<SetStateAction<boolean>>;
};

export const Modal: FC<TProps> = ({ children, show, setShow }) => {
    if (!show) {
        return null;
    }

    return (
        <Background onClick={() => setShow(false)}>
            <div onClick={(event) => event.stopPropagation()}>{children}</div>
        </Background>
    );
};
